import { Card, CardContent } from '@/components/ui/card';
import React from 'react';

export function SelectionModeCard({ selectedRanges, activeChartIds }: any) {
  return (
    <Card className="mb-4 bg-yellow-50 border-yellow-200">
      <CardContent className="pt-4">
        <div className="text-sm text-yellow-800">
          <strong>Selection Mode Active:</strong> Drag on charts to select ranges. Selected:{' '}
          {selectedRanges.length > 0 ? selectedRanges.length / activeChartIds.length : 0} ranges across{' '}
          {activeChartIds.length} charts
        </div>
      </CardContent>
    </Card>
  );
}
